(function ($) {
  // $(document).ready(function () {
  //   if ($('.accordion').length) {
  //     $('.accordion').each(function () {
  //       const $this = $(this),
  //             $content = $this.find('.accordion__content');
  
  //       if ($this.hasClass('accordion--open')) {
  //         $content.slideDown(100);
  //       }
  //     });
  //   }
  // });

  $(document).on('click', '.accordion__trigger .btn', function (e) {
    e.preventDefault();
    const $this = $(this),
          $parent = $this.parents('.accordion'),
          $content = $parent.find('.accordion__content');

    if ($parent.hasClass('accordion--open')) {
      $content.stop(true).slideUp(300);
      $parent.removeClass('accordion--open');
    } else {
      $parent.addClass('accordion--open');
      $content.stop(true).slideDown(300);
    }
  });
})(jQuery);